import React, { useEffect } from 'react';
import classNames from 'classnames';
import { SortableElement } from 'react-sortable-hoc';
import { type CFMediaVideo, ImageType } from '@types';
import addComponent from '@utils/addComponent';
import Image from '@components/Image';
import IconTrash from '@components/icons/IconTrash';
import { Validator } from '@components/Validator';
import VideoCaptureModal from '@components/VideoCaptureModal';
import getVideoDetail from '@utils/getVideoDetail';
import uploadVideoCover from '@utils/uploadVideoCover';
import { getMediaUrl } from '@utils/urlMakers';

interface Props {
  data: CFMediaVideo;
  listIndex: number;
  onCoverChange: (src: string, index: number) => void;
  onDelete: (index: number) => void;
}

function CVideoItem({ data, listIndex, onCoverChange, onDelete }: Props) {
  const { mediaUrl, mediaName, coverMediaUrl } = data;

  useEffect(() => {
    if (!coverMediaUrl) {
      getVideoDetail(mediaUrl).then((result) => {
        onCoverChange(result.coverUrl, listIndex);
      });
    }
  }, []);

  const handleCapture = () => {
    addComponent((remove) => (
      <VideoCaptureModal
        coverSrc={coverMediaUrl}
        videoUrl={getMediaUrl(mediaUrl)}
        title="视频封面图"
        onRequestClose={remove}
        onConfirm={async (file) => {
          const url = await uploadVideoCover(file);
          onCoverChange(url, listIndex);
        }}
      />
    ));
  };

  return (
    <Validator
      value={coverMediaUrl}
      validFn={(value) => !!value}
      warningMessage="请等待视频封面上传完成"
    >
      {({ value, warning }) => (
        <div
          className={classNames(
            'relative mb-10 flex h-35 select-none items-center rounded bg-black-border px-10',
            {
              'ring-2 ring-red': warning,
            }
          )}
        >
          <div
            className="h-16 w-16 flex-shrink-0 cursor-pointer bg-black"
            onClick={handleCapture}
          >
            {value && (
              <Image className="h-16 w-16" src={value} type={ImageType.media} />
            )}
          </div>
          <div className="mx-5 flex-grow truncate text-base text-white">
            {mediaName}
          </div>
          <IconTrash
            className="flex-shrink-0"
            onClick={() => onDelete(listIndex)}
          />
        </div>
      )}
    </Validator>
  );
}

export default SortableElement(CVideoItem);
